import React       from 'react';

import { Fa }      from '../../atoms/Icons/Fa';
import { Box }     from '../../atoms/Layout/Box/Box';
import { Text }    from '../../atoms/Text/Text';
import { Game }    from '../../models/Game';
import { Freshdesk } from '../Freshdesk/Freshdesk';
import { ErrorBoundary } from '../../atoms/ErrorBoundary';
import classNames from 'classnames';
import styles from './HaveQuestions.css';

type HaveQuestionsProps = {
    className?: string;
    game?: Game;
};

export class HaveQuestions extends React.Component<HaveQuestionsProps> {
    render() {
        const { className, game } = this.props;

        return (
            <Container className = {className}>
                <QuestionBorder />
                <Box align = "center" justify = "center" paddingT = "xs" paddingB = "xs" wrap = "wrap">
                    <Fa icon = "question-circle" />
                    <Text bold={true} size = "lg" className = {styles.nobr}>&nbsp;Have Questions?&nbsp;</Text>

                    <ErrorBoundary swallow = {true}>
                        <Freshdesk size = "lg" game = {game}/>
                    </ErrorBoundary>

                    <Delimeter/>

                    <PrivacyPolicyLink
                        href = "https://www.arkadium.com/privacy-policy/?utm_medium=referral&utm_source=arena&utm_content=policy"
                        target = "_blank" rel = "noopener"
                    >

                        <Text size = "lg" bold={true} className = {styles.nobr} >Privacy Policy</Text>
                    </PrivacyPolicyLink>
                </Box>
                <QuestionBorder />
            </Container>
        );
    }
}
const Delimeter = (props: any) => <div className={styles.delimeter} {...props}/>;
const PrivacyPolicyLink = (props: any) => <a className = {styles.privacyPolicy} {...props} />;
const Container = ({ className, ...props }: any) => <div className = {classNames(styles.container, className)} {...props} />;
const QuestionBorder = (props: any) => <div className = {styles.questionBorder} {...props} />;
